import React from 'react';
import { useSelector } from 'react-redux';
import { AnyObject } from 'final-form';
import { components } from 'react-select';

import Colors from 'Wpds/colors/ColorConstants';
import WpIcon from 'Wpds/components/icon/WpIcon';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

import * as UsersSelectors from 'Shared/selectors/Users.selectors';
import { getFullNameOrEmail } from 'Shared/helpers';

import './SubGoalFieldOption.scss';
import { GoalIcons } from 'Shared/constants/types';

const SubGoalFieldOption = (props: AnyObject) => {
  const owner = useSelector(state => UsersSelectors.getUserByUserId(state, { userId: props.data.assigneeId })).toJS();
  const { tr } = useTranslation();

  return (
    <components.Option {...props}>
      <div data-test={props.label} className="SubGoalFieldOption__title d-flex align-items-center">
        <div className="mr-2">
          <WpIcon name={props.data.icon || GoalIcons.ice_cream} color={Colors.blue[500]} />
        </div>
        {props.label}
      </div>
      <div className="SubGoalFieldOption__owner ml-4">
        {tr('perform.goals.sub_goal_field.owner_label', getFullNameOrEmail(owner))}
      </div>
    </components.Option>
  );
};

export default SubGoalFieldOption;
